import * as i18next from 'i18next'
import { rootWidget } from './site/root/rootWidget'
// STYLING IMPORTS
// import './Shared/Frontend/utils/svgSymbols'
import './styling/custom-theme/stylesheets/spa.scss' // PROJECT
// import LazyStyles from './styling/custom-theme/stylesheets/spa.lazy.scss' // PROJECT (LAZY)
// LazyStyles.use()
import './site/utils/globals'
import 'lazysizes'
import { RootProps, RootState } from './site/root/rootState'

import { createRoot } from 'react-dom/client'

const maybeRemoveSSRRoot = (useSSR: string) => (state: RootState) => {
  const root = document.getElementById('root')
  const ssrRoot = document.getElementById('rootSSR')

  if (!useSSR) {
    ssrRoot?.parentNode?.removeChild(ssrRoot)
    return
  }

  let releaseCounter = 20

  let hasAsyncLoading = (e: any, parent: any) => {
    if (e == undefined) return false
    let entries = Object.entries(e)
    if ((e as any)['kind'] == 'fromPromise') return false
    for (let [key, value] of entries) {
      if (value == null || value == undefined) continue
      if (typeof value === 'function') continue
      if (value instanceof Date) continue

      if ((value as any)['type'] == 'async-widget') {
        if ((value as any)['kind'] == 'loading') {
          return true
        }
      }

      if (typeof value === 'string' || value instanceof String) continue
      let hasValueAsyncLoading = hasAsyncLoading(value, e)
      if (hasValueAsyncLoading) return true
    }
    return false
  }

  let firstTime = true

  let removeSSR = () => {
    setTimeout(
      () => {
        firstTime = false
        if (hasAsyncLoading(state, undefined) && releaseCounter > 0) {
          releaseCounter--
          removeSSR()
          return
        }

        if (root) {
          root.style.display = ''
        }
        if (ssrRoot) {
          ssrRoot.style.display = 'none'
          setTimeout(() => ssrRoot.parentNode?.removeChild(ssrRoot), 100)
        }
      },
      firstTime ? 1000 : 200
    )
  }

  removeSSR()
}

export const main = async (props: RootProps) => {
  // setTimeout(() => welcomePopup(), 500)

  let headers = new Headers()
  headers.append('content-type', 'application/json')

  let res = await fetch(`/api/v1/sharepoint/translations.json`, {
    method: 'get',
    credentials: 'include',
    headers: headers
  })
  let resources = await res.json()

  await i18next.default.init({
    ns: ['error'],
    lng: 'nl',
    resources: resources
  })

  const container = document.querySelector('#root')
  if (container !== null) {
    const root = createRoot(container)
    root.render(
      rootWidget(props).run(state => {
        maybeRemoveSSRRoot(props.useSSR)(state)
        return state
      })
    )
  }
}

main({footerFormId: window.footerFormId, useSSR: window.useSSR})
